import useClassNames from '@medflex/hooks/useClassNames';
import PropTypes from 'prop-types';
import React from 'react';
import Button from '../Button';
import { IconClose } from '../Icons';

const SessionsParticipantListItem = ({
  reference,
  onDelete,
  children,
  className,
  readOnly,
  ...props
}) => {
  const cn = useClassNames(
    () => ['flex', 'border', 'border-slate-200', 'border-l-0', className],
    [className],
  );
  return (
    <li className={cn} data-component="SessionsParticipantListItem" {...props}>
      {/* additional div, because tailwind doesn't allow
      to set individual border colors per side */}
      <div className="flex flex-auto items-center border-l-4 border-blue-600 pl-4 pr-2 h-12">
        <div className="font-semibold">{children}</div>
        <div className="ml-2 flex-auto">{reference}</div>
        {!readOnly && (
          <Button shape="circle" kind="secondary:ghost" onClick={onDelete}>
            <IconClose className="flex items-center text-blue-600" size="4" />
          </Button>
        )}
      </div>
    </li>
  );
};

SessionsParticipantListItem.propTypes = {
  children: PropTypes.node,
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.func,
    PropTypes.array,
    PropTypes.object,
  ]),
  reference: PropTypes.string,
  onDelete: PropTypes.func,
  readOnly: PropTypes.bool,
};

SessionsParticipantListItem.defaultProps = {
  reference: null,
  onDelete: () => {},
  readOnly: false,
};

export default SessionsParticipantListItem;
